/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************************!*\
  !*** ./src/assets/js/main-custom-cart.js ***!
  \*******************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// to do: phantom setlocalstorage clear
var CustomCart = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomCart, _HTMLElement);
  var _super = _createSuper(CustomCart);
  function CustomCart() {
    var _this;
    _classCallCheck(this, CustomCart);
    _this = _super.call(this);
    _this.productGrid = _this.querySelector('.main-custom-cart-grid__products-grid');
    _this.cards = _this.querySelectorAll('.custom-cart-remove');
    _this.broughtModal = _this.querySelector('brought-modal');
    _this.successModal = _this.querySelector('success-modal');
    _this.emptyText = _this.querySelector('.empty-cart-text');
    _this.form = _this.querySelector('.main-custom-cart__input-form');
    _this.staticInfo = _this.querySelector('.main-custom-cart__selected-info');
    _this.staticInfoName = _this.staticInfo.querySelector('.main-custom-cart__input--selected-name');
    _this.staticInfoEmail = _this.staticInfo.querySelector('.main-custom-cart__input--selected-email');
    _this.staticInfoRoom = _this.staticInfo.querySelector('.main-custom-cart__selected-info-room');
    _this.measuredContainer = _this.querySelector('.main-custom-cart__you-have-measured');
    _this.measuredGrid = _this.measuredContainer.querySelector('.predictive-search__grid');
    _this.createOrderEndPoint = _this.getAttribute('data-create-order-endpoint');
    _this.deleteProductEndPoint = _this.getAttribute('data-delete-order-endpoint');
    _this.currency = _this.dataset.currency;
    _this.tryText = _this.getAttribute('data-try-text');
    _this.finishText = _this.getAttribute('data-finish-text');
    _this.tryOnButton = _this.querySelector('.try-on-info');
    _this.errorContainer = document.querySelector('.main-custom-cart__error');
    _this.isValidating = false;
    _this.formErrors = new Set();
    _this.cancelButton = _this.querySelector('.cancel-fitting-btn');
    _this.cancelModal = _this.querySelector('cancel-modal');

    // Add event listener for cancel fitting confirmation
    _this.cancelModal.addEventListener('fitting-cancelled', function () {
      return _this.handleCancelFitting();
    });
    _this.updateEmptyState(); // Add initial empty state check

    _this.cartCountBubble = document.querySelector('#cart-icon-bubble');
    _this.updateCartCount(); // Initial count update
    return _this;
  }
  _createClass(CustomCart, [{
    key: "updateCartCount",
    value: function () {
      var _updateCartCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var totalCount, cartJson, storedProducts, products, cartBubble;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              totalCount = 0; // Get cart items count
              _context.next = 3;
              return this.getCartJson();
            case 3:
              cartJson = _context.sent;
              totalCount += cartJson.items.length;

              // Get localStorage items count
              storedProducts = localStorage.getItem('products');
              if (storedProducts) {
                products = JSON.parse(storedProducts);
                totalCount += products.length;
              }
              console.log(totalCount, 'totalCount');
              if (totalCount === 0) {
                this.cartCountBubble.classList.add('tw-hidden');
              } else {
                this.cartCountBubble.classList.remove('tw-hidden');
              }
              cartBubble = document.querySelector('#cart-icon-bubble');
              if (cartBubble) {
                cartBubble.textContent = totalCount;
              }

              // Update the cart bubble count
              if (this.cartCountBubble) {
                this.cartCountBubble.querySelector('span').textContent = totalCount;
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateCartCount() {
        return _updateCartCount.apply(this, arguments);
      }
      return updateCartCount;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
      this.updateEmptyState();
      this.checkCartAndLocalStorage();
      this.loadProductsFromLocalStorage();
      this.setupStaticInfoListeners();
      this.setupFormValidation();
      this.updateCartCount();
    }
  }, {
    key: "updateEmptyState",
    value: function () {
      var _updateEmptyState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var cartJson, hasLocalStorageProducts, hasUserInfo, _this$emptyText, _this$emptyText2, _this$productGrid, _this$measuredContain, _this$measuredContain2, _this$measuredContain3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getCartJson();
            case 2:
              cartJson = _context2.sent;
              hasLocalStorageProducts = localStorage.getItem('products') !== null;
              hasUserInfo = localStorage.getItem('userInfo') !== null;
              if (cartJson.items.length === 0 && !hasLocalStorageProducts && !hasUserInfo) {
                this.classList.add('main-custom-cart-grid--empty');
                (_this$emptyText = this.emptyText) === null || _this$emptyText === void 0 || _this$emptyText.classList.remove('tw-hidden');
              } else {
                this.classList.remove('main-custom-cart-grid--empty');
                (_this$emptyText2 = this.emptyText) === null || _this$emptyText2 === void 0 || _this$emptyText2.classList.add('tw-hidden');

                // If cart is empty but we have localStorage data, ensure measured container is visible
                // and add no-borders class
                if (cartJson.items.length === 0 && (hasLocalStorageProducts || hasUserInfo)) {
                  (_this$productGrid = this.productGrid) === null || _this$productGrid === void 0 || _this$productGrid.classList.add('tw-hidden');
                  (_this$measuredContain = this.measuredContainer) === null || _this$measuredContain === void 0 || _this$measuredContain.classList.remove('tw-hidden');
                  (_this$measuredContain2 = this.measuredContainer) === null || _this$measuredContain2 === void 0 || _this$measuredContain2.classList.add('no-borders'); // Add no-borders class
                } else {
                  (_this$measuredContain3 = this.measuredContainer) === null || _this$measuredContain3 === void 0 || _this$measuredContain3.classList.remove('no-borders'); // Remove when not needed
                }
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateEmptyState() {
        return _updateEmptyState.apply(this, arguments);
      }
      return updateEmptyState;
    }()
  }, {
    key: "setupFormValidation",
    value: function setupFormValidation() {
      var _this2 = this;
      // Add validation styles to required inputs
      var requiredInputs = this.staticInfo.querySelectorAll('input[required]');
      requiredInputs.forEach(function (input) {
        // Add invalid style class
        input.classList.add('tw-invalid:tw-border-red-500', 'tw-invalid:tw-bg-red-50');

        // Add validation message element after each input
        var validationMessage = document.createElement('div');
        validationMessage.className = 'validation-message tw-text-red-500 tw-text-sm tw-mt-1 tw-hidden';
        validationMessage.textContent = "".concat(input.getAttribute('placeholder'), " is required");
        input.parentNode.appendChild(validationMessage);

        // Add input event listeners
        input.addEventListener('input', function () {
          _this2.validateInput(input);
          _this2.updateSubmitButton();
        });
        input.addEventListener('blur', function () {
          _this2.validateInput(input);
          _this2.updateSubmitButton();
        });
      });

      // Setup form submission handling
      this.staticInfo.addEventListener('submit', function (e) {
        e.preventDefault();
        if (_this2.validateForm()) {
          // If cart is empty, handle finish fitting
          _this2.getCartJson().then(function (cart) {
            if (cart.items.length === 0) {
              _this2.handleFinish();
            } else {
              _this2.handleTryOnMore();
            }
          });
        }
      });

      // Initial validation state
      this.updateSubmitButton();
    }
  }, {
    key: "updateSubmitButton",
    value: function updateSubmitButton() {
      var submitButton = this.staticInfo.querySelector('.try-on-info');
      var isValid = this.formErrors.size === 0;
      if (!isValid) {
        submitButton.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
        submitButton.disabled = true;
      } else {
        submitButton.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
        submitButton.disabled = false;
      }
    }
  }, {
    key: "validateInput",
    value: function validateInput(input) {
      var validationMessage = input.parentNode.querySelector('.validation-message');
      if (!input.value.trim()) {
        input.classList.add('tw-border-red-500');
        validationMessage.classList.remove('tw-hidden');
        this.formErrors.add(input.name);
        return false;
      } else {
        if (input.type === 'email' && !this.isValidEmail(input.value)) {
          input.classList.add('tw-border-red-500');
          validationMessage.textContent = 'Please enter a valid email address';
          validationMessage.classList.remove('tw-hidden');
          this.formErrors.add(input.name);
          return false;
        }
        input.classList.remove('tw-border-red-500');
        validationMessage.classList.add('tw-hidden');
        this.formErrors["delete"](input.name);
        return true;
      }
    }
  }, {
    key: "isValidEmail",
    value: function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this3 = this;
      var inputs = this.staticInfo.querySelectorAll('input[required]');
      var isValid = true;
      inputs.forEach(function (input) {
        if (!_this3.validateInput(input)) {
          isValid = false;
        }
      });
      return isValid;
    }
  }, {
    key: "setupStaticInfoListeners",
    value: function setupStaticInfoListeners() {
      var _this4 = this;
      var nameInput = this.staticInfo.querySelector('.main-custom-cart__input--selected-name input');
      var emailInput = this.staticInfo.querySelector('.main-custom-cart__input--selected-email input');
      nameInput.addEventListener('change', function () {
        _this4.validateInput(nameInput);
        _this4.updateUserInfoInLocalStorage();
      });
      emailInput.addEventListener('change', function () {
        _this4.validateInput(emailInput);
        _this4.updateUserInfoInLocalStorage();
      });
    }
  }, {
    key: "updateUserInfoInLocalStorage",
    value: function updateUserInfoInLocalStorage() {
      var userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      var nameInput = this.staticInfoName.querySelector('input');
      var emailInput = this.staticInfoEmail.querySelector('input');

      // Update the userInfo object with new values
      userInfo.name = nameInput.value;
      userInfo.email = emailInput.value;
      // Preserve the existing cabin value
      userInfo.cabin = userInfo.cabin || 'default';

      // Save back to localStorage
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  }, {
    key: "loadProductsFromLocalStorage",
    value: function loadProductsFromLocalStorage() {
      var storedProducts = localStorage.getItem('products');
      if (storedProducts) {
        var products = JSON.parse(storedProducts);
        this.fillMeasuredGrid(products);
      }
    }

    // Method to check the cart and local storage, then adjust UI and event listeners
  }, {
    key: "checkCartAndLocalStorage",
    value: function checkCartAndLocalStorage() {
      var _this5 = this;
      this.getCartJson().then(function (cart) {
        // Remove all existing event listeners from the button
        var newButton = _this5.tryOnButton.cloneNode(true);
        _this5.tryOnButton.parentNode.replaceChild(newButton, _this5.tryOnButton);
        _this5.tryOnButton = newButton;
        if (localStorage.getItem('userInfo') && cart.items.length === 0) {
          _this5.tryOnButton.textContent = _this5.finishText;
          console.log('finish text is set');

          // Remove form submit event and add click event for finish
          _this5.form.removeEventListener('submit', _this5.handleFormSubmit);
          _this5.form.addEventListener('submit', function (e) {
            e.preventDefault();
          });
          _this5.tryOnButton.addEventListener('click', function (e) {
            e.preventDefault();
            _this5.handleFinish();
          });
        } else {
          _this5.tryOnButton.textContent = _this5.tryText;

          // Remove form submit prevention and add try on more functionality
          _this5.form.removeEventListener('submit', function (e) {
            return e.preventDefault();
          });
          _this5.form.addEventListener('submit', _this5.handleFormSubmit);
          _this5.tryOnButton.addEventListener('click', function () {
            return _this5.handleTryOnMore();
          });
        }
      });
    }
  }, {
    key: "handleFinish",
    value: function () {
      var _handleFinish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this6 = this;
        var userInfo, bodyData, response, serverResponse;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              userInfo = JSON.parse(localStorage.getItem('userInfo'));
              if (userInfo) {
                _context3.next = 4;
                break;
              }
              throw new Error('User info not found in local storage');
            case 4:
              bodyData = {
                products: [],
                // Empty array as requested
                cabin: userInfo.cabin,
                email: this.staticInfoEmail.querySelector('input').value,
                name: this.staticInfoName.querySelector('input').value,
                shop_name: this.form.querySelector('[name="shop_name"]').value,
                locale: this.form.querySelector('[name="locale"]').value
              }; // this.broughtModal.open();
              _context3.next = 7;
              return fetch(this.createOrderEndPoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
              });
            case 7:
              response = _context3.sent;
              if (response.ok) {
                _context3.next = 10;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 10:
              _context3.next = 12;
              return response.json();
            case 12:
              serverResponse = _context3.sent;
              console.log('Finish fitting response:', serverResponse);
              if (serverResponse.status === 'success') {
                this.clearCart();
                this.successModal.open();
                this.clearLocalStorage();
              } else {
                console.error('Server responded with error:', serverResponse);
                this.showError();
              }
              _context3.next = 21;
              break;
            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](0);
              console.error('Error during finish fitting:', _context3.t0);
              this.showError();
            case 21:
              _context3.prev = 21;
              setTimeout(function () {
                _this6.broughtModal.close();
              }, 1000);
              return _context3.finish(21);
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 17, 21, 24]]);
      }));
      function handleFinish() {
        return _handleFinish.apply(this, arguments);
      }
      return handleFinish;
    }()
  }, {
    key: "handleTryOnMore",
    value: function handleTryOnMore() {
      // Prefill the form with local storage data
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.form.querySelector('[name="name"]').value = userInfo.name;
        this.form.querySelector('[name="email"]').value = userInfo.email;
        // Assuming 'cabin' is the field name for the room in your form
        this.form.querySelector('[name="cabin"]').value = userInfo.cabin;
      }

      // Submit the form
      this.onFormSubmit();
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
      this.checkLocalStorage();
      this.updateCancelButton();
    }
  }, {
    key: "updateCancelButton",
    value: function updateCancelButton() {
      if (localStorage.getItem('userInfo') || this.getCartJson().then(function (cart) {
        return cart.items.length > 0;
      })) {
        this.cancelButton.classList.remove('tw-hidden');
      } else {
        this.cancelButton.classList.add('tw-hidden');
      }
    }
  }, {
    key: "toggleMeasured",
    value: function toggleMeasured() {
      this.measuredContainer.classList.add('tw-hidden');
      this.productGrid.classList.remove('tw-hidden');
    }
  }, {
    key: "onShowMeasured",
    value: function onShowMeasured() {
      var _this7 = this;
      if (localStorage.getItem('products')) {
        this.measuredContainer.classList.remove('tw-hidden');
        // Add check for empty cart here too
        this.getCartJson().then(function (cartJson) {
          if (cartJson.items.length === 0) {
            _this7.measuredContainer.classList.add('no-borders');
          } else {
            _this7.measuredContainer.classList.remove('no-borders');
          }
        });
      }
    }
  }, {
    key: "onToggleStaticInfo",
    value: function onToggleStaticInfo() {
      this.form.classList.add('tw-hidden');
      this.staticInfo.classList.remove('tw-hidden');
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this8 = this;
      this.cards.forEach(function (card) {
        card.addEventListener('click', function () {
          _this8.removeItem(card.getAttribute('data-id'));
        });
      });
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        _this8.onFormSubmit();
      });
      this.cancelButton.addEventListener('click', function () {
        _this8.cancelModal.open();
      });
    }
  }, {
    key: "handleCancelFitting",
    value: function () {
      var _handleCancelFitting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var cartCountBubble, nameInput, emailInput, cartJson;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.clearCart();
            case 3:
              this.clearLocalStorage();
              _context4.next = 6;
              return this.updateEmptyState();
            case 6:
              // Fetch and update cart content
              this.fetchContent();

              // Reset all UI states
              this.productGrid.innerHTML = '';
              this.measuredGrid.innerHTML = '';
              this.form.reset();
              this.staticInfo.classList.add('tw-hidden');
              this.form.classList.remove('tw-hidden');
              this.measuredContainer.classList.add('tw-hidden');
              this.cancelButton.classList.add('tw-hidden');
              this.emptyText.classList.remove('tw-hidden');
              this.classList.add('main-custom-cart-grid--empty');

              // Update cart count in header
              cartCountBubble = document.querySelector('.cart-count-bubble span');
              if (cartCountBubble) {
                cartCountBubble.innerText = '0';
              }

              // Update UI state
              this.checkCartAndLocalStorage();

              // Reset form fields if needed
              nameInput = this.form.querySelector('[name="name"]');
              emailInput = this.form.querySelector('[name="email"]');
              if (nameInput) nameInput.value = '';
              if (emailInput) emailInput.value = '';

              // Additional fetch to ensure cart state is properly reflected
              _context4.next = 25;
              return this.getCartJson();
            case 25:
              cartJson = _context4.sent;
              if (cartJson.item_count === 0) {
                this.emptyText.classList.remove('tw-hidden');
                this.classList.add('main-custom-cart-grid--empty');
              }
              window.location.reload();
              _context4.next = 34;
              break;
            case 30:
              _context4.prev = 30;
              _context4.t0 = _context4["catch"](0);
              console.error('Error cancelling fitting:', _context4.t0);
              this.showError();
            case 34:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 30]]);
      }));
      function handleCancelFitting() {
        return _handleCancelFitting.apply(this, arguments);
      }
      return handleCancelFitting;
    }()
  }, {
    key: "removeProductFromLocalStorage",
    value: function () {
      var _removeProductFromLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(productId) {
        var userInfo, email, response, serverResponse, updatedProducts;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              console.log('Removing product:', productId);
              this.classList.add('loading');
              userInfo = JSON.parse(localStorage.getItem('userInfo'));
              email = userInfo ? userInfo.email : null; // Ensure there's a fallback in case userInfo is not set
              console.log(email, 'email');
              console.log(productId, 'productId');
              _context5.prev = 6;
              _context5.next = 9;
              return fetch(this.deleteProductEndPoint, {
                method: 'POST',
                mode: 'cors',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  variant_id: productId,
                  email: email,
                  shop_name: window.primaryDomain
                })
              });
            case 9:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 12;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 12:
              _context5.next = 14;
              return response.json();
            case 14:
              serverResponse = _context5.sent;
              console.log(serverResponse, 'serverResponse 3');
              if (serverResponse.status === 'success') {
                // Update products in local storage
                updatedProducts = serverResponse.products.items.map(function (product) {
                  return {
                    id: product.variant.legacyResourceId,
                    displayName: product.variant.displayName,
                    price: product.variant.price,
                    variant_id: product.variant.legacyResourceId,
                    image: product.image ? product.image.url : '',
                    selectedOptions: product.variant.selectedOptions.map(function (option) {
                      return {
                        name: option.name,
                        value: option.value
                      };
                    }),
                    url: product.product.onlineStorePreviewUrl ? product.product.onlineStorePreviewUrl : '#'
                    // other properties as needed
                  };
                });

                localStorage.setItem('products', JSON.stringify(updatedProducts));

                // Update UI based on new products
                this.fillMeasuredGrid(updatedProducts);
                this.updateCartCount();
                this.classList.remove('loading');
                this.classList.remove('main-custom-cart-grid--empty');
              } else if (serverResponse.status === 'cart_empty') {
                localStorage.removeItem('products');
                this.toggleMeasured();
                this.updateCartCount();
                this.classList.remove('loading');
                this.emptyText.classList.remove('tw-hidden');
                this.classList.add('main-custom-cart-grid--empty');
              } else {
                // Handle server error or unexpected response
                console.error('Server responded with error:', serverResponse);
                this.showError();
                this.classList.remove('loading');
              }
              _context5.next = 24;
              break;
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](6);
              console.error('Error deleting product:', _context5.t0);
              this.showError();
              this.classList.remove('loading');
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[6, 19]]);
      }));
      function removeProductFromLocalStorage(_x) {
        return _removeProductFromLocalStorage.apply(this, arguments);
      }
      return removeProductFromLocalStorage;
    }()
  }, {
    key: "showError",
    value: function showError() {
      var _this9 = this;
      this.errorContainer.classList.remove('tw-hidden');
      setTimeout(function () {
        _this9.errorContainer.classList.add('tw-hidden');
      }, 15000);
    }
  }, {
    key: "clearCart",
    value: function clearCart() {
      var _this10 = this;
      fetch('/cart/clear.js', {
        method: 'POST'
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this10.productGrid.innerHTML = '';
        _this10.updateCartCount(); // Add this
        console.log('Cart has been cleared:', data);
      })["catch"](function (error) {
        console.error('Error clearing cart:', error);
        _this10.showError();
      });
    }
  }, {
    key: "getCartJson",
    value: function () {
      var _getCartJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetch('/cart.js');
            case 2:
              response = _context6.sent;
              _context6.next = 5;
              return response.json();
            case 5:
              return _context6.abrupt("return", _context6.sent);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function getCartJson() {
        return _getCartJson.apply(this, arguments);
      }
      return getCartJson;
    }()
  }, {
    key: "clearLocalStorage",
    value: function clearLocalStorage() {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('products');
      this.updateCartCount(); // Add this
      this.updateEmptyState();
    }
  }, {
    key: "onFormSubmit",
    value: function () {
      var _onFormSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this11 = this;
        var formData, cartJson, bodyData, response, serverResponse, productsFromResponse;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              formData = new FormData(this.form);
              _context7.next = 3;
              return this.getCartJson();
            case 3:
              cartJson = _context7.sent;
              // Assuming this method gets current cart items or similar
              // Prepare the data to be sent to the server
              bodyData = {
                // Your bodyData structure here. Ensure this matches your backend expectations.
                products: cartJson.items.map(function (item) {
                  return item.variant_id;
                }),
                // Example to map cart items to product variant IDs
                cabin: formData.get('cabin'),
                email: formData.get('email'),
                name: formData.get('name'),
                shop_name: formData.get('shop_name'),
                locale: formData.get('locale')
              };
              _context7.prev = 5;
              this.broughtModal.open();
              // Make a POST request to your endpoint
              _context7.next = 9;
              return fetch(this.createOrderEndPoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
              });
            case 9:
              response = _context7.sent;
              if (response.ok) {
                _context7.next = 12;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 12:
              _context7.next = 14;
              return response.json();
            case 14:
              serverResponse = _context7.sent;
              console.log(serverResponse, 'serverResponse');
              console.log(serverResponse, 'serverResponse 2');

              // Check if the response status is 'success'
              if (serverResponse.status === 'success') {
                // Directly map over serverResponse.products as it already contains the product objects
                productsFromResponse = serverResponse.products.items.map(function (product) {
                  return {
                    id: product.variant.legacyResourceId,
                    displayName: product.variant.displayName,
                    price: product.variant.price,
                    variant_id: product.variant.legacyResourceId,
                    image: product.image ? product.image.url : '',
                    selectedOptions: product.variant.selectedOptions.map(function (option) {
                      return {
                        name: option.name,
                        value: option.value
                      };
                    }),
                    url: product.product.onlineStorePreviewUrl ? product.product.onlineStorePreviewUrl : '#'
                    // other properties as needed
                  };
                }); // Save the processed products to localStorage

                localStorage.setItem('products', JSON.stringify(productsFromResponse));

                // Update UI based on new products
                this.fillMeasuredGrid(productsFromResponse);

                // Clear cart, update local storage and UI state as necessary
                this.clearCart();
                this.storeInLocalStorage(); // Store user info or other necessary details
                this.checkLocalStorage(); // Refresh local storage checks, if necessary
                this.checkCartAndLocalStorage(); // Ensure UI is consistent with cart and local storage state
                this.onShowMeasured(); // Show measured products, if applicable
                this.updateCartCount();
              } else {
                // Handle server error or unexpected response
                console.error('Server responded with error:', serverResponse);
                this.showError();
              }
              console.log('clear start');
              setTimeout(function () {
                _this11.checkCartAndLocalStorage();
              }, 1000);
              console.log('clear end');
              _context7.next = 23;
              return this.updateEmptyState();
            case 23:
              _context7.next = 29;
              break;
            case 25:
              _context7.prev = 25;
              _context7.t0 = _context7["catch"](5);
              console.error('Fetching error:', _context7.t0);
              this.showError();
            case 29:
              _context7.prev = 29;
              setTimeout(function () {
                _this11.broughtModal.close();
              }, 1000); // Adjust timing as necessary
              return _context7.finish(29);
            case 32:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[5, 25, 29, 32]]);
      }));
      function onFormSubmit() {
        return _onFormSubmit.apply(this, arguments);
      }
      return onFormSubmit;
    }()
  }, {
    key: "storeInLocalStorage",
    value: function storeInLocalStorage() {
      var formData = new FormData(this.form);
      var userInfo = {
        name: formData.get('name'),
        // Assuming 'name' is a field in the form
        email: formData.get('email'),
        cabin: formData.get('cabin')
      };
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  }, {
    key: "fillStaticInfoFromLocalStorage",
    value: function fillStaticInfoFromLocalStorage() {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.staticInfoName.querySelector('input').value = userInfo.name;
        this.staticInfoEmail.querySelector('input').value = userInfo.email;
        this.staticInfoRoom.textContent = userInfo.cabin;
      }
    }

    // Method to safely update the try-on button
  }, {
    key: "updateTryOnButton",
    value: function updateTryOnButton() {
      // Remove existing event listeners to prevent duplicates
      var oldButton = this.tryOnButton;
      var newButton = oldButton.cloneNode(true);
      oldButton.parentNode.replaceChild(newButton, oldButton);
      this.tryOnButton = newButton;

      // Now add the new event listener to this.tryOnButton
      this.checkCartAndLocalStorage();
    }
  }, {
    key: "checkLocalStorage",
    value: function checkLocalStorage() {
      var _this12 = this;
      if (localStorage.getItem('userInfo')) {
        this.onToggleStaticInfo();
        this.fillStaticInfoFromLocalStorage();
      }
      if (localStorage.getItem('products')) {
        this.getCartJson().then(function (cart) {
          if (cart.items.length === 0) {
            _this12.productGrid.classList.add('tw-hidden');
            _this12.measuredContainer.classList.remove('tw-hidden');
            _this12.measuredContainer.classList.add('no-borders'); // Add when cart is empty
          } else {
            _this12.measuredContainer.classList.remove('tw-hidden');
            _this12.measuredContainer.classList.remove('no-borders'); // Remove when cart has items
          }

          var products = JSON.parse(localStorage.getItem('products'));
          _this12.fillMeasuredGrid(products);
        });
      }
    }
  }, {
    key: "fillMeasuredGrid",
    value: function fillMeasuredGrid(products) {
      var _this13 = this;
      this.measuredGrid.innerHTML = ''; // Clear existing content
      products.forEach(function (product) {
        console.log(product, 'product');
        var productHTML = "\n                <div class=\"small-product-card tw-relative tw-flex tw-flex-col tw-justify-start tw-w-[132px]\" data-id=\"".concat(product.variant_id, "\">\n                    <button class=\"custom-cart-remove tw-absolute tw-rounded-full tw-bg-[#051c2d] tw-p-[5px] tw-top-2 tw-right-2 tw-z-4\" data-id=\"").concat(product.variant_id, "\">\n                        <svg width=\"11.093262\" height=\"11.092163\" viewBox=\"0 0 11.0933 11.0922\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                            <desc>\n                                    Created with Pixso.\n                            </desc>\n                            <defs/>\n                            <rect id=\"Form\" x=\"1.095703\" y=\"0.354004\" width=\"13.638611\" height=\"1.047446\" transform=\"rotate(45 1.095703 0.354004)\" fill=\"#FFFFFF\" fill-opacity=\"1.000000\"/>\n                            <rect id=\"Form\" x=\"1.095703\" y=\"0.354004\" width=\"13.638611\" height=\"1.047446\" transform=\"rotate(45 1.095703 0.354004)\" stroke=\"#FFFFFF\" stroke-opacity=\"1.000000\" stroke-width=\"0.500000\"/>\n                            <rect id=\"Form\" x=\"0.353516\" y=\"9.997559\" width=\"13.638611\" height=\"1.047446\" transform=\"rotate(-45 0.353516 9.997559)\" fill=\"#FFFFFF\" fill-opacity=\"1.000000\"/>\n                            <rect id=\"Form\" x=\"0.353516\" y=\"9.997559\" width=\"13.638611\" height=\"1.047446\" transform=\"rotate(-45 0.353516 9.997559)\" stroke=\"#FFFFFF\" stroke-opacity=\"1.000000\" stroke-width=\"0.500000\"/>\n                        </svg>   \n                    </button>\n                    <a href=\"").concat(product.url, "\" class=\"small-product-card__image tw-w-[132px] tw-h-[183px]\">\n                        <img src=\"").concat(product.image, "\" alt=\"").concat(product.displayName, "\" class=\"predictive-search__product-image tw-w-full tw-h-full tw-object-cover\">\n                    </a>\n                    <a href=\"").concat(product.url, "\" class=\"small-product-card__title tw-mt-3 tw-text-font24 tw-text-[#051C2C]\">").concat(product.displayName.split(' -')[0], "</a>\n                    \n                    <div class=\"small-product-card__price tw-mt-1 tw-text-font20\">\n                        <strong>").concat(product.price, "</strong> ").concat(_this13.currency, "\n                    </div>\n                    ").concat(product.selectedOptions.map(function (option) {
          return "\n                        <div class=\"tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-2 tw-text-[#4D4E56] tw-text-font12\">\n                            <div>".concat(option.name, ":</div>\n                            <div>").concat(option.value, "</div>\n                        </div>\n                    ");
        }).join(''), "\n                </div>\n            ");
        _this13.measuredGrid.insertAdjacentHTML('beforeend', productHTML);
      });

      // Add event listeners for each remove button
      this.measuredGrid.querySelectorAll('.custom-cart-remove').forEach(function (button) {
        button.addEventListener('click', function (e) {
          var productId = parseInt(button.getAttribute('data-id'));
          _this13.removeProductFromLocalStorage(productId);
        });
      });
    }
  }, {
    key: "fetchContent",
    value: function fetchContent() {
      var _this14 = this;
      this.classList.add('loading');
      fetch(window.location.pathname).then(function (response) {
        return response.text();
      }).then(function (data) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var newProductGrid = doc.querySelector('.main-custom-cart-grid__products-grid');
        if (newProductGrid) {
          _this14.productGrid.innerHTML = newProductGrid.innerHTML;
          _this14.cards = _this14.querySelectorAll('.custom-cart-remove');
          _this14.cards.forEach(function (card) {
            card.addEventListener('click', function () {
              _this14.removeItem(card.getAttribute('data-id'));
            });
          });
        }
        _this14.classList.remove('loading');
      })["catch"](function (error) {
        console.error('Error fetching content:', error);
        _this14.showError();
        _this14.classList.remove('loading');
      });
    }

    // Modify existing methods to call updateCartCount when needed
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(id) {
        var _this15 = this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.classList.add('loading');
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: id,
                  quantity: 0
                })
              }).then(function (response) {
                return response.json();
              }).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
                  var hasLocalStorageProducts, hasUserInfo, _this15$productGrid, _this15$measuredConta, _this15$measuredConta2, _this15$emptyText, _this15$measuredConta3;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        hasLocalStorageProducts = localStorage.getItem('products') !== null;
                        hasUserInfo = localStorage.getItem('userInfo') !== null;
                        if (data.items.length === 0 && (hasLocalStorageProducts || hasUserInfo)) {
                          (_this15$productGrid = _this15.productGrid) === null || _this15$productGrid === void 0 || _this15$productGrid.classList.add('tw-hidden');
                          (_this15$measuredConta = _this15.measuredContainer) === null || _this15$measuredConta === void 0 || _this15$measuredConta.classList.remove('tw-hidden');
                          (_this15$measuredConta2 = _this15.measuredContainer) === null || _this15$measuredConta2 === void 0 || _this15$measuredConta2.classList.add('no-borders');
                          (_this15$emptyText = _this15.emptyText) === null || _this15$emptyText === void 0 || _this15$emptyText.classList.add('tw-hidden');
                          _this15.classList.remove('main-custom-cart-grid--empty');
                        } else {
                          (_this15$measuredConta3 = _this15.measuredContainer) === null || _this15$measuredConta3 === void 0 || _this15$measuredConta3.classList.remove('no-borders');
                        }
                        _context8.next = 5;
                        return _this15.updateEmptyState();
                      case 5:
                        _this15.fetchContent();
                        _this15.updateCartCount(); // Add this
                        _this15.classList.remove('loading');
                        _this15.checkCartAndLocalStorage();
                      case 9:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }())["catch"](function (error) {
                console.error('Error removing item:', error);
                _this15.showError();
                _this15.classList.remove('loading');
              });
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function removeItem(_x2) {
        return _removeItem.apply(this, arguments);
      }
      return removeItem;
    }()
  }]);
  return CustomCart;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the new element
customElements.define('custom-cart', CustomCart);
var BringModal = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(BringModal, _HTMLElement2);
  var _super2 = _createSuper(BringModal);
  function BringModal() {
    var _this16;
    _classCallCheck(this, BringModal);
    _this16 = _super2.call(this);
    _this16.overlay = _this16.querySelector('.brought-overlay');
    return _this16;
  }
  _createClass(BringModal, [{
    key: "open",
    value: function open() {
      this.classList.remove('tw-hidden');
      this.classList.add('tw-flex');
    }
  }, {
    key: "close",
    value: function close() {
      this.classList.add('tw-hidden');
      this.classList.remove('tw-flex');
    }
  }]);
  return BringModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the new element
customElements.define('brought-modal', BringModal);
var SuccessModal = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(SuccessModal, _HTMLElement3);
  var _super3 = _createSuper(SuccessModal);
  function SuccessModal() {
    _classCallCheck(this, SuccessModal);
    return _super3.call(this);
  }
  _createClass(SuccessModal, [{
    key: "open",
    value: function open() {
      this.classList.remove('tw-hidden');
      this.classList.add('tw-flex');
    }
  }, {
    key: "close",
    value: function close() {
      this.classList.add('tw-hidden');
      this.classList.remove('tw-flex');
    }
  }]);
  return SuccessModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the new element
customElements.define('success-modal', SuccessModal);
var CancelModal = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(CancelModal, _HTMLElement4);
  var _super4 = _createSuper(CancelModal);
  function CancelModal() {
    var _this17;
    _classCallCheck(this, CancelModal);
    _this17 = _super4.call(this);
    _this17.overlay = _this17.querySelector('.brought-overlay');
    _this17.confirmButton = _this17.querySelector('.confirm-cancel');
    _this17.declineButton = _this17.querySelector('.decline-cancel');
    _this17.setupListeners();
    return _this17;
  }
  _createClass(CancelModal, [{
    key: "setupListeners",
    value: function setupListeners() {
      var _this18 = this;
      this.confirmButton.addEventListener('click', function () {
        _this18.dispatchEvent(new CustomEvent('fitting-cancelled'));
        _this18.close();
      });
      this.declineButton.addEventListener('click', function () {
        _this18.close();
      });
    }
  }, {
    key: "open",
    value: function open() {
      this.classList.remove('tw-hidden');
      this.classList.add('tw-flex');
    }
  }, {
    key: "close",
    value: function close() {
      this.classList.add('tw-hidden');
      this.classList.remove('tw-flex');
    }
  }]);
  return CancelModal;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('cancel-modal', CancelModal);
/******/ })()
;